import { generateMethod, url } from '@bukalapak/vpjs/api';

const externalService = window.APP.apiURL;

export default {
  registerInvoice: generateMethod({
    prefix: externalService,
    address: url`invoices`,
    method: 'post',
  }),
};
